import { AccessGuard } from '@/components/layout/access-guard'

export function ProtectedCoachRoute() {
  return (
    <AccessGuard
      routeId="coach.root"
      deniedTitle="Coach access required"
      deniedMessage="This account is valid, but it cannot use the Coach Portal."
    />
  )
}
